import { Injectable, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, CanActivate , ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class NavigationToBlockGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) { 
    const mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    const user = JSON.parse(sessionStorage.getItem('user'));
    let navigationToblock;
    if(mdmDetails) { 
      if (mdmDetails.productCode === 'ADDPMDM') {
        this.router.navigate(['/home']);
      } else if(user.user.fanSignedUpStatus === 'NONE'){ 
        navigationToblock = ['/enrollmentTool'];
      } else{ 
            if( mdmDetails.productCode === 'ADDPZTE' ){ 
            navigationToblock = ['/productselection'];
            }else {
              navigationToblock = ['/enrollmentTool','/productselection'];
            }
      }
    } else {
      navigationToblock = ['/enrollmentTool'];
    }
    navigationToblock.forEach( pages => { 
            if(state.url === pages){ 
              this.router.navigate(['/home']);
              return false;
            }
    });
    return true;
  }
}
